import LightBox from '../../../general/components/LightBox';
import MarkSafe from '../../../general/components/MarkSafe';

const Error = ({error, onErrorConfirm}) => (
    <LightBox onClose={onErrorConfirm} hint>
        <MarkSafe Element="div" html={error} />
    </LightBox>
);

export default Error;
